import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Angioplasty from './pages/Angioplasty';
import HipReplacement from './pages/HipReplacement';
import BoneMarrow from './pages/BoneMarrow';
import MedicalOpinion from './pages/MedicalOpinion';
import AirportPickUp from './pages/AirportPickUp';
import ApplyVisa from './pages/ApplyVisa';
import VisaExtension from './pages/VisaExtension';
import Cardiology from './pages/Cardiology';
import Orthopedics from './pages/Orthopedics';
import Oncology from './pages/Oncology';
import VisaGuides from './pages/VisaGuides';
import CostQuote from './pages/CostQuote';


import Dental from './pages/Dental';
import Ayurveda from './pages/Ayurveda';
import Sitemap from './pages/Sitemap';
import SubmitQuery from './pages/SubmitQuery';
import DoctorConsultation from './pages/DoctorConsultation';
import VisaAssistance from './pages/VisaAssistance';
import MedicalUpdates from './pages/MedicalUpdates';
import SuccessStories from './pages/SuccessStories';
import TravelAdvisories from './pages/TravelAdvisories';
import Accreditation from './pages/Accreditation';
import TeleConsultation from './pages/TeleConsultation';
import VisaProcessing from './pages/VisaProcessing';
import FollowUpCare from './pages/FollowUpCare';
import DoctorNetwork from './pages/DoctorNetwork';
import PatientSupport from './pages/PatientSupport';
import Analytics from './pages/Analytics';
import FAQ from './pages/FAQ';
import Library from './pages/Library';
import Help from './pages/Help';
import Terms from './pages/Terms';
import Policies from './pages/Policies';
import CompareCosts from './pages/CompareCosts';
import SearchResults from './pages/SearchResults';
import Destinations from './pages/Destinations';
import Treatments from './pages/Treatments';
import Hospitals from './pages/Hospitals';

import './App.css';

function App() {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <Router>
      <div className="app-container">
        <Header />



        {/* Master Navbar with Active State Props */}
        <div className={`nav-wrapper-box ${navOpen ? 'show-mobile-bar' : ''}`}>
          <Navbar closeMobileMenu={() => setNavOpen(false)} />
        </div>

        {/* Live News Ticker Strip */}
        <div className="ticker-container">
          <span className="ticker-title">LIVE UPDATES →</span>
          <marquee className="ticker-text" scrollamount="4">
            ✦ JCI Accredited Hospitals in India open priority booking slots for International Cardiac patients. ✦ Hassle-free 48-hour Medical Visa invitation processing live for 2026.
          </marquee>
        </div>

        {/* Page Delivery Window */}
        <div className="content-wrapper">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/cardiology" element={<Cardiology />} />
            <Route path="/orthopedics" element={<Orthopedics />} />
            <Route path="/oncology" element={<Oncology />} />
            <Route path="/guides" element={<VisaGuides />} />
            <Route path="/services" element={<CostQuote />} />
            <Route path="/angioplasty" element={<Angioplasty />} />
            <Route path="/hip-replacement" element={<HipReplacement />} />
            <Route path="/bone-marrow" element={<BoneMarrow />} />
            <Route path="/medical-opinion" element={<MedicalOpinion />} />
            <Route path="/airport-pickup" element={<AirportPickUp />} />
            <Route path="/apply-visa" element={<ApplyVisa />} />
            <Route path="/visa-extension" element={<VisaExtension />} />

            {/* Newly added routes for Home page connections */}
            <Route path="/dental" element={<Dental />} />
            <Route path="/ayurveda" element={<Ayurveda />} />
            <Route path="/sitemap" element={<Sitemap />} />
            <Route path="/submit-query" element={<SubmitQuery />} />

            <Route path="/doctor-consultation" element={<DoctorConsultation />} />
            <Route path="/visa-assistance" element={<VisaAssistance />} />
            <Route path="/medical-updates" element={<MedicalUpdates />} />
            <Route path="/success-stories" element={<SuccessStories />} />
            <Route path="/travel-advisories" element={<TravelAdvisories />} />
            <Route path="/accreditation" element={<Accreditation />} />
            <Route path="/tele-consultation" element={<TeleConsultation />} />
            <Route path="/visa-processing" element={<VisaProcessing />} />
            <Route path="/followup-care" element={<FollowUpCare />} />
            <Route path="/follow-up-care" element={<FollowUpCare />} />
            <Route path="/doctor-network" element={<DoctorNetwork />} />
            <Route path="/patient-support" element={<PatientSupport />} />
            <Route path="/visa-guides" element={<VisaGuides />} />
            {/* Core structural search and map destinations routes */}
            <Route path="/search-results" element={<SearchResults />} />
            <Route path="/destinations" element={<Destinations />} />
            <Route path="/treatments" element={<Treatments />} />
            <Route path="/hospitals" element={<Hospitals />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/library" element={<Library />} />
            <Route path="/help" element={<Help />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/policies" element={<Policies />} />
            <Route path="/compare-costs" element={<CompareCosts />} />
          </Routes>
        </div>

        <Footer />
        <a
          href="https://wa.me/916205355169?text=Hello,%20I%20am%20seeking%20independent%20medical%20travel%20information."
          className="whatsapp-float-btn"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat via WhatsApp"
        >
          <span style={{ fontSize: '28px' }}>💬</span>
        </a>
      </div>
    </Router>
  );
}

export default App;